<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :total-items="totalItems"
          :loading="loading"
          :pagination.sync="pagination"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.receipt_no }}</td>
            <td>{{ props.item.product_name }}</td>
            <td>{{ props.item.created_at }}</td>
            <td>{{ props.item.amount }}</td>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-layout row wrap justify-end class="px-3">
          <v-flex xs12 sm6 md3 lg1 xl1 class="mr-2">
            <v-text-field
              label="Total"
              readonly
              v-model="totalItems"
              :disabled="loading"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md3 lg1 xl1 class="mr-2">
            <v-autocomplete
              :items="pages"
              label="Pages"
              v-model="page"
              :suffix="'/'+pagination.totalPages"
              :disabled="loading"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md3 lg1 xl1>
            <v-select
              v-model="rowsPerPage"
              label="Rows"
              :items="rowsPerPageItems"
              :disabled="loading"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment-timezone'
import transactionService from '@/services/transaction'

import paginationMixin from '@/mixins/pagination'

export default {
  mixins: [paginationMixin],

  props: {
    locationId: [String, null]
  },

  data () {
    return {
      loading: false,
      transactions: [],
      headers: [
        { text: 'Receipt No.', value: 'receipt_no', sortable: false },
        { text: 'Product', value: 'product_name', sortable: false },
        { text: 'Created At', value: 'created_at' },
        { text: 'Amount', value: 'amount' }
      ]
    }
  },

  async created () {
    await this.updateTable()
  },

  computed: {
    items () {
      return this.transactions.map(transaction => {
        return {
          receipt_no: transaction.receipt_no,
          product_name: transaction.product.name_zh_hk,
          created_at: moment.unix(transaction.created_at).utc().tz('Asia/Hong_Kong').format('YYYY-MM-DD HH:mm:ss'),
          amount: (transaction.amount / 10).toFixed(1)
        }
      })
    }
  },

  async mounted () {
    this.page = 1
  },

  methods: {
    async updateTable () {
      this.loading = true
      this.transactions = []

      const filters = {}
      if (this.filter) {
        filters[this.filter] = this.filterValue
      }

      const { data } = await transactionService.get(
        this.locationId,
        this.page,
        this.rowsPerPage,
        this.pagination.sortBy,
        this.pagination.descending ? 'desc' : 'asc',
        filters
      )

      this.transactions = data.data.data
      this.totalItems = data.data.total
      this.loading = false
    },

    upperCaseFirstLetter (str) {
      return str[0].toUpperCase() + str.slice(1)
    }
  }
}
</script>
